import React from "react";
import moment from "moment-timezone";

function ItemAgendaCard({ cliente, servico, intervalo, status, data }) {
  const handleClick = () => {
    //alert("[Em breve] Detalhes de consulta");
  };

  // Escolhe a cor de fundo com base no status
  const getStatusStyle = () => {
    switch (status) {
      case "Agendada":
        return "bg-orange-500";
      case "Cancelada":
        return "bg-red-500";
      default:
        return "bg-green-600";
    }
  };

  // Extrai iniciais do nome (máx. 3 letras)
  const getInitials = (name) => {
    if (!name) return "";
    const nameArray = name.split(" ");
    let initials = "";
    for (let i = 0; i < nameArray.length && initials.length < 3; i++) {
      initials += nameArray[i].charAt(0).toUpperCase();
    }
    return initials;
  };


  // Converte data UTC para horário de Brasília
  const dataFormatada = data
    ? moment(data).format("DD/MM/YYYY")
    : "-";

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={handleClick}
      className="mt-0 mx-auto h-[150px] sm:h-[110px] flex flex-row items-center bg-white rounded-lg shadow-sm border border-gray-300 cursor-pointer"
    >
      {/* Círculo com as iniciais */}
      <div className="w-10 h-10 rounded-full bg-[#003D42] flex items-center justify-center ml-3 -mt-3">
        <span className="text-white font-bold text-[16px]">
          {getInitials(cliente)}
        </span>
      </div>

      {/* Informações do agendamento */}
      <div className="ml-4 flex flex-col justify-center">
        <span className="text-[14px] text-gray-600 font-medium">
          {intervalo}
        </span>
        <span className="text-[14px] font-medium mt-2">{cliente}</span>
        <span className="text-[14px] text-gray-500 font-medium mt-1">
          {servico || "Fisioterapia"}
        </span>
        <span className="text-[14px] text-gray-600 font-medium mt-1">
          {dataFormatada}
        </span>
      </div>

      {/* Status */}
      <div className="ml-auto mr-3">
        <div
          className={`min-w-[100px] h-[35px] px-2 rounded flex items-center justify-center font-bold text-white text-center ${getStatusStyle()}`}
        >
          {status}
        </div>
      </div>
    </div>
  );
}

export default ItemAgendaCard;
